import React, { Component } from 'react';

import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import moment from 'moment';


class RelatedBulkUploadRecord extends Component {

//TODO: Duplicated with WFMI
  getDateString = (value) =>
  {
  return (value) ? moment(new Date(value)).format("MM/DD/YYYY h:mm A") : "";
  }

  getYesNo = (value) =>
  {
  return (value && (value === 1 || value === "1")) ? "Yes" : "No";
  }

  render()
  {
    return (
      <Paper elevation={3}>
      <Table size="small">
      <TableBody>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Bulk Upload ID:</TableCell>
        <TableCell>{this.props.record.BulkUploadID}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Local Incident ID:</TableCell>
        <TableCell>{this.props.record.LocalIncidentID}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Fire Discovery Date:</TableCell>
        <TableCell>{this.props.record.FireDiscoveryDate}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Fire Discovery Time:</TableCell>
        <TableCell>{this.props.record.FireDiscoveryTime}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Fire Reporting Agency Unit Identifier:</TableCell>
        <TableCell>{this.props.record.FireReportingAgencyUnitIdentifier}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>State:</TableCell>
        <TableCell>{this.props.record.State}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Latitude:</TableCell>
        <TableCell>{this.props.record.Latitude}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Longitude:</TableCell>
        <TableCell>{this.props.record.Longitude}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Statistical Cause Code:</TableCell>
        <TableCell>{this.props.record.StatisticalCauseCode}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Final Fire Acre Quantity:</TableCell>
        <TableCell>{this.props.record.FinalFireAcreQuantity}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Fire Containment Date:</TableCell>
        <TableCell>{this.props.record.FireContainmentDate}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Fire Containment Time:</TableCell>
        <TableCell>{this.props.record.FireContainmentTime}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Incident Name:</TableCell>
        <TableCell>{this.props.record.IncidentName}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>State FIPS:</TableCell>
        <TableCell>{this.props.record.StateFIPS}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>County:</TableCell>
        <TableCell>{this.props.record.County}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>County FIPS:</TableCell>
        <TableCell>{this.props.record.CountyFIPS}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>District:</TableCell>
        <TableCell>{this.props.record.District}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Ownership Code:</TableCell>
        <TableCell>{this.props.record.OwnershipCode}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Residences Threatened:</TableCell>
        <TableCell>{this.props.record.ResidencesThreatened}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Residences Destroyed:</TableCell>
        <TableCell>{this.props.record.ResidencesDestroyed}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Fire Department ID:</TableCell>
        <TableCell>{this.props.record.FireDepartmentID}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Fire Discovery Date:</TableCell>
        <TableCell>{this.props.record.FireDiscoveryDateTime}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Other Structures Threatened:</TableCell>
        <TableCell>{this.props.record.OtherStructuresThreatened}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Other Structures Destroyed:</TableCell>
        <TableCell>{this.props.record.OtherStructuresDestroyed}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Number Injuries:</TableCell>
        <TableCell>{this.props.record.NumberInjuries}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Number Fatalities:</TableCell>
        <TableCell>{this.props.record.NumberFatalities}</TableCell>
      </TableRow>
      </TableBody>
      </Table>
      </Paper>
  )
  }
}

export default RelatedBulkUploadRecord;
